import React, { Component } from 'react'
import { connect } from 'react-redux'
import { push } from 'react-router-redux'
import { withRouter } from 'react-router'

import { SearchIcon } from 'icons'

import css from './GlobalSearch.scss'

export class GlobalSearch extends Component {
  constructor (props) {
    super(props)
    const term = props.location && props.location.query && props.location.query.term
    this.state = { searchTerm: term || '' }
    this.handleSearchSubmit = this.handleSearchSubmit.bind(this)
    this.handleSearchChange = this.handleSearchChange.bind(this)
  }

  componentDidUpdate (prevProps) {
    const term = this.props.location && this.props.location.query && this.props.location.query.term
    const prevTerm = prevProps.location && prevProps.location.query && prevProps.location.query.term
    if (term !== prevTerm) {
      this.setState({ searchTerm: term || '' }) // eslint-disable-line react/no-did-update-set-state
    }
  }

  handleSearchChange (e) {
    this.setState({ searchTerm: e.target.value })
  }

  handleSearchSubmit (e) {
    e.preventDefault()
    const { searchTerm } = this.state
    if (searchTerm && searchTerm.trim().length > 0) {
      this.props.push(`/search?term=${encodeURIComponent(searchTerm.trim())}`)
    }
  }

  render () {
    return (
      <form className={css.searchForm} onSubmit={this.handleSearchSubmit}>
        <label htmlFor='global-search-input' className='sr-only'>
          Search for webinars, events, and more
        </label>
        <input
          id='global-search-input'
          className={css.searchInput}
          type='text'
          placeholder='Enhanced search for webinars, events, and more'
          value={this.state.searchTerm}
          onChange={this.handleSearchChange}
        />
        <button className={css.searchButton} type='submit' aria-label='Search'>
          <SearchIcon className={css.searchButtonIcon} aria-hidden='true' />
        </button>
      </form>
    )
  }
}

GlobalSearch.propTypes = {
  push: React.PropTypes.func.isRequired
}

export default withRouter(connect(null, { push })(GlobalSearch))
